const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'L',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const monthFirstSlashDateFormat = 'MM/DD/YYYY';

export { MY_FORMATS, monthFirstSlashDateFormat };
